/*eslint-disable*/
export default [
    {
        path: 'tools/abacus/settings',
        name: 'tools/abacus:settings',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "abacus" */'../../components/tools/abacus/Form.vue'),
        meta: {
            title: 'router.router_abacus',
            prev: {
                name: 'dashboard'
            }
        },
    },
    {
        path: 'tools/abacus/play',
        name: 'tools/abacus',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "abacus" */'../../components/tools/abacus/PlayBox.vue'),
        meta: {
            title: 'router.router_abacus',
            prev: {
                name: 'dashboard',
                certainForBreadcrumbs: true
            }
        },
        props: true
    },
    {
        path: 'tools/metronome',
        name: 'tools/metronome',
        component: () => import('../../components/tools/metronome/Form.vue'),
        meta: {
            title: 'router.router_metronome',
            prev: {
                name: 'dashboard'
            }
        },
        props: true
    }
]
